import { create } from 'zustand';

interface User {
  id: string;
  name: string;
  email: string;
  isFirstAccess: boolean;
  role: Role;
}

interface Role {
  id: string;
  name: string;
  permissions: Permissions[];
}

interface Permissions {
  id: string;
  description: string;
  isActive: boolean;
}

type States = {
  isLoading: boolean;
  userRole: string[];
  user: User | null;
  permissionMap: Record<string, string>;
};

type Actions = {
  setIsLoading: (loadingState: boolean) => void;
  setUser: (user: User) => void;
  clearUser: () => void;
};

type UserStore = Actions & States;

const initialValues = {
  isLoading: false,
  user: undefined,
};

export const useUserStore = create<UserStore>((set) => ({
  ...initialValues,
  userRole: [],
  permissionMap: {},
  user: null,
  setIsLoading: (loadingState: boolean) => set({ isLoading: loadingState }),
  setUser: (user: User) => {
    const { permissions } = user.role;
    const permissionMap = Object.fromEntries(permissions.map((p) => [p.id, p.description]));
    const userRole = permissions.map((p) => p.id);
    set({ user, userRole, permissionMap });
  },
  clearUser: () => set({ ...initialValues }),
}));
